module.exports = __webpack_public_path__ + "static/media/pdf.a8feaf8e.svg";